import React, { useEffect, useState } from "react";
import { Col, Dropdown, Form, Modal, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import DropdownForLocation from "../../DropdownForLocation/DropdownForLocation";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Input2 from "../Forms/Input/Input2";
import Button from "../Forms/Button/Button";
import { address } from "../../../Data/data";
import {
  ADD_DELIVERY_ADDRESS,
  ADD_EDIT_USER,
  GET_CITY,
  GET_COUNTRY,
  GET_STATE,
  LIST_DELIVERY_ADDRESS,
} from "../../../Redux/SagaAction/actions";
import { useDispatch, useSelector } from "react-redux";
import { userpopupShowingCount } from "../../../Redux/Slices/AuthSlice";
import DropDown from "../../DropDownCM/DropDown";

const schema = yup.object().shape({
  firstName: yup.string().required("Please Enter First Name"),
  lastName: yup.string().required("Please Enter Last Name"),
  phoneNo: yup.string().required("Please Enter Phone Number"),
  email: yup
    .string()
    .email("Please Enter Valid Email")
    .required("Please Enter Email"),
  houseNo: yup
    .string()
    .required("Please Enter Your House Number / Street Name"),
  areaName: yup.string().required("Please Enter Landmark or Area Name"),
  cityId: yup.object().required("Please Select City"),
  stateId: yup.object().required("Please Select State"),
  zipCode: yup
    .string()
    // .matches(/^[0-9]+$/, "ZIP Code must contain only numbers")
    .required("Please Enter ZIP Code"),
  countryId: yup.object().required("Please Select Country"),
});

const AddAddress = ({ show, setShow, title, editId, addressData ,clear}) => {
  const { countryData, stateData, cityData } = useSelector(
    (e) => e.CountrySlice
  );
  // const { addressData } = useSelector((e) => e.DeliveryAddressSlice);
  const { t } = useTranslation();
  // let [num, setNum] = useState(0);
  const dispatch = useDispatch();
  const [userData, setuserData] = useState([address]); // use [address] only for rendering one modal and address for showing details
  const [accountDetail, setAccountDetails] = useState(null);
  const {
    register,
    trigger,
    handleSubmit,
    control,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: addressData,
    mode: "all",
  });
  // GET COUNTRY DATA START

  useEffect(() => {
    dispatch({ type: GET_COUNTRY });
  }, []);

  useEffect(() => {
    if (watch("countryId")?._id) {
      dispatch({
        type: GET_STATE,
        payload: { country_id: watch("countryId")?._id },
      });
    }
  }, [watch("countryId")?._id]);

  useEffect(() => {
    if (watch("stateId")?._id) {
      dispatch({
        type: GET_CITY,
        payload: { state_id: watch("stateId")?._id },
      });
    }
  }, [watch("stateId")?._id]);

  useEffect(() => {
    if (addressData) {
      for (const key in addressData) {
        // setValue()
        console.log(key, "Keyyy", addressData[key]);
      }
    }
  }, [addressData]);
  // GET COUNTRY DATA ENDS

  const onSubmit = (data) => {
    if (data) {
      const addData = {
        firstName: data?.firstName,
        lastName: data?.lastName,
        phoneNo: data?.phoneNo,
        email: data?.email,
        countryId: data?.countryId?._id,
        stateId: data?.stateId?._id,
        cityId: data?.cityId?._id,
        houseNo: data?.houseNo,
        areaName: data?.areaName,
        zipCode: data?.zipCode,
      };
      if (data?.addressId) {
        addData.addressId = data?.addressId
      }
      dispatch({
        type: ADD_DELIVERY_ADDRESS,
        payload: addData,
        callback: () => {
          dispatch(userpopupShowingCount(0));
          dispatch({ type: LIST_DELIVERY_ADDRESS });
          clear()
        },
      });
    }
    // if (data) {
    //   setAccountDetails(data);
    //   dispatch({
    //     type: ADD_EDIT_USER,
    //     payload: {
    //       addressId: "648961f3b8944a36464a9d73",
    //       houseNo: "1016-17 Gala empire, near drive-in road",
    //     },
    //   });
    //   reset({
    //     fname: "",
    //     lname: "",
    //     phoneno: "",
    //     email: "",
    //     houseNo: "",
    //     landmark: "",
    //     city: "",
    //     state: "",
    //     zipcode: "",
    //     country: "",
    //   });
    //   handleClose();
    // }
  };
  // useEffect(() => {
  //   // setNum(num++);
  //   // setuserData(address);

  // }, [editId]);
  console.log(addressData, "addressData");
  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          clear()
          dispatch(userpopupShowingCount(0))}}
        centered
        className="custom-modal add-address-modal"
        size="lg"
        backdrop="static"
        keyboard={false}
        // key={i}
      >
        <Modal.Header closeButton>
          <div className="title">
            {" "}
            {addressData ? "Edit Address" : "Add Address"}{" "}
          </div>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmit)}>
            <>
              <div className="personal-detail">
                <div className="address-title">
                  {`${t("myaccount.addaddress.personaldetail")}`}
                </div>
                <Row>
                  <Col lg="6">
                    <div className="input-wrapper">
                      <label> {`${t("signupmodal.fname")}`}</label>
                      <input
                        type="text"
                        name="firstName"
                        {...register("firstName")}
                        className={
                          errors?.firstName?.message
                            ? "custom-input error-input"
                            : "custom-input"
                        }
                        // autoFocus
                      />
                      {errors?.firstName?.message && (
                        <span className="error">
                          {errors?.firstName?.message}
                        </span>
                      )}
                    </div>
                  </Col>

                  <Col lg="6">
                    <div className="input-wrapper">
                      <label> {`${t("signupmodal.lname")}`}</label>
                      <input
                        type="text"
                        {...register("lastName")}
                        name="lastName"
                        className={
                          errors?.lastName?.message
                            ? "custom-input error-input"
                            : "custom-input"
                        }
                      />
                      {errors?.lastName?.message && (
                        <span className="error">
                          {errors?.lastName?.message}
                        </span>
                      )}
                    </div>
                  </Col>

                  <Col lg="6">
                    <div className="input-wrapper">
                      <label> {`${t("signupmodal.email")}`}</label>
                      <input
                        type="text"
                        name="email"
                        {...register("email")}
                        className={
                          errors?.email?.message
                            ? "custom-input error-input"
                            : "custom-input"
                        }
                      />
                      {errors?.email?.message && (
                        <span className="error">{errors?.email?.message}</span>
                      )}
                    </div>
                  </Col>

                  <Col lg="6">
                    <div className="input-wrapper">
                      <label> {`${t("signupmodal.phoneno")}`}</label>
                      <input
                        type="text"
                        {...register("phoneNo")}
                        name="phoneNo"
                        minLength="6"
                        maxLength="10"
                        className={
                          errors?.phoneNo?.message
                            ? "custom-input error-input"
                            : "custom-input"
                        }
                        onKeyDown={(e) => {
                          if (
                            ![
                              "ArrowLeft",
                              "ArrowRight",
                              "Delete",
                              "Backspace",
                              ...Array.from({ length: 10 }, (_, i) =>
                                i.toString()
                              ),
                            ].includes(e.key)
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                      {errors?.phoneNo?.message && (
                        <span className="error">
                          {errors?.phoneNo?.message}
                        </span>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>

              <div className="address-detail">
                <div className="address-title">
                  {`${t("myaccount.addaddress.addressdetail")}`}
                </div>
                <Row>
                  <Col lg="6">
                    <div className="input-wrapper">
                      <label> {`${t("myaccount.addaddress.houseno")}`}</label>
                      <textarea
                        {...register("houseNo")}
                        className={
                          errors?.houseNo?.message
                            ? "custom-input error-input"
                            : "custom-input"
                        }
                      />

                      {errors?.houseNo?.message && (
                        <span className="error">
                          {errors?.houseNo?.message}
                        </span>
                      )}
                    </div>
                  </Col>
                  <Col lg="6">
                    <div className="input-wrapper">
                      <label> {`${t("myaccount.addaddress.landmark")}`}</label>
                      <textarea
                        {...register("areaName")}
                        className={
                          errors?.areaName?.message
                            ? "custom-input error-input"
                            : "custom-input"
                        }
                      />
                      {errors?.areaName?.message && (
                        <span className="error">
                          {errors?.areaName?.message}
                        </span>
                      )}
                    </div>
                  </Col>
                  <Col lg="6">
                    <div className="input-wrapper">
                      <label> {`${t("myaccount.addaddress.country")}`}</label>
                      {/* <input
                            type="text"
                            {...register("city")}
                            name="city"
                            className={
                              errors.city
                                ? "custom-input error-input"
                                : "custom-input"
                            }
                          />
                          {errors.city && (
                            <span className="error">
                              {t(`signupValidation.city`)}
                            </span>
                          )} */}
                      <div
                        className={`customDropdown ${
                          errors?.countryId?.message ? "error" : ""
                        }`}
                      >
                        <Controller
                          control={control}
                          name="countryId"
                          render={({ field: { onChange, value } }) => (
                            <Dropdown
                              onSelect={(e) => {
                                onChange(JSON.parse(e));
                                setValue("stateId", null);
                                setValue("cityId", null);
                              }}
                            >
                              <Dropdown.Toggle
                                variant="transparent"
                                id="dropdown-basic"
                                className="icontrol"
                              >
                                {value?.name ?? "Select"}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {countryData?.map((list, index) => {
                                  return (
                                    <Dropdown.Item
                                      key={index}
                                      eventKey={JSON.stringify(list)}
                                      className={
                                        list?._id === value?._id
                                          ? "actives"
                                          : ""
                                      }
                                    >
                                      {list.name}
                                    </Dropdown.Item>
                                  );
                                })}
                              </Dropdown.Menu>
                            </Dropdown>
                          )}
                        />
                      </div>
                      {errors?.countryId?.message && (
                        <span className="error">
                          {errors?.countryId?.message}
                        </span>
                      )}
                    </div>
                  </Col>
                  <Col lg="6">
                    <div className="input-wrapper">
                      <label> {`${t("myaccount.addaddress.zipcode")}`}</label>
                      <input
                        type="text"
                        {...register("zipCode")}
                        name="zipCode"
                        minlength="5"
                        maxlength="10"
                        className={
                          errors?.zipCode?.message
                            ? "custom-input error-input"
                            : "custom-input"
                        }
                        onKeyDown={(e) => {
                          if (
                            ![
                              "ArrowLeft",
                              "ArrowRight",
                              "Delete",
                              "Backspace",
                              ...Array.from({ length: 10 }, (_, i) =>
                                i.toString()
                              ),
                            ].includes(e.key)
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                      {errors?.zipCode?.message && (
                        <span className="error">
                          {errors?.zipCode?.message}
                        </span>
                      )}
                    </div>
                  </Col>
                  <Col lg="6">
                    <div
                      className={
                        errors?.stateId?.message
                          ? "input-wrapper error-wrapper"
                          : "input-wrapper"
                      }
                    >
                      <label> {`${t("myaccount.addaddress.state")}`}</label>
                      {/* <DropdownForLocation
                            id={true}
                            name="state"
                            control={control}
                            isSearchable
                            className={
                              errors.state
                                ? "custom-input error-input"
                                : "custom-input"
                            }
                            options={[
                              { _id: 1, name: "Gujarat" },
                              { _id: 2, name: "Rajasthan" },
                              { _id: 3, name: "Uttar Pradesh" },
                              { _id: 4, name: "Maharashtra" },
                            ]}
                            register={register}
                          />
                          {errors.state && (
                            <span className="error">
                              {t(`signupValidation.state`)}
                            </span>
                          )} */}
                      <div
                        className={`customDropdown ${
                          errors?.stateId?.message ? "error" : ""
                        }`}
                      >
                        <Controller
                          control={control}
                          name="stateId"
                          render={({ field: { onChange, value } }) => (
                            <Dropdown
                              onSelect={(e) => {
                                onChange(JSON.parse(e));
                                setValue("cityId", null);
                              }}
                            >
                              <Dropdown.Toggle
                                disabled={!Boolean(watch("countryId")?._id)}
                                variant="transparent"
                                id="dropdown-basic"
                                className="icontrol"
                              >
                                {value?.name ?? "Select"}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {stateData?.map((list, index) => {
                                  return (
                                    <Dropdown.Item
                                      key={index}
                                      eventKey={JSON.stringify(list)}
                                      className={
                                        list?._id === value?._id
                                          ? "actives"
                                          : ""
                                      }
                                    >
                                      {list.name}
                                    </Dropdown.Item>
                                  );
                                })}
                              </Dropdown.Menu>
                            </Dropdown>
                          )}
                        />
                      </div>
                      {errors?.stateId?.message && (
                        <span className="error">
                          {errors?.stateId?.message}
                        </span>
                      )}
                      {/* <DropDown name="city" control={control}/> */}
                    </div>
                  </Col>
                  <Col lg="6">
                    <div
                      className={
                        errors?.countryId?.message
                          ? "input-wrapper error-wrapper"
                          : "input-wrapper"
                      }
                    >
                      <label> {`${t("myaccount.addaddress.city")}`}</label>
                      {/* <DropdownForLocation
                            id={true}
                            className={
                              errors.country
                                ? "custom-input error-input"
                                : "custom-input"
                            }
                            name="country"
                            control={control}
                            isSearchable
                            options={[
                              { _id: 1, name: "India" },
                              { _id: 2, name: "Australia" },
                              { _id: 3, name: "Canada" },
                              { _id: 4, name: "USA" },
                            ]}
                            register={register}
                          /> */}
                      <div
                        className={`customDropdown ${
                          errors?.cityId?.message ? "error" : ""
                        }`}
                      >
                        <Controller
                          control={control}
                          name="cityId"
                          render={({ field: { onChange, value } }) => (
                            <Dropdown
                              onSelect={(e) => {
                                onChange(JSON.parse(e));
                              }}
                            >
                              <Dropdown.Toggle
                                disabled={
                                  !(
                                    Boolean(watch("countryId")?._id) &&
                                    Boolean(watch("stateId")?._id)
                                  )
                                }
                                variant="transparent"
                                id="dropdown-basic"
                                className="icontrol"
                              >
                                {value?.name ?? "Select"}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {cityData?.map((list, index) => {
                                  return (
                                    <Dropdown.Item
                                      key={index}
                                      eventKey={JSON.stringify(list)}
                                      className={
                                        list?._id === value?._id
                                          ? "actives"
                                          : ""
                                      }
                                    >
                                      {list.name}
                                    </Dropdown.Item>
                                  );
                                })}
                              </Dropdown.Menu>
                            </Dropdown>
                          )}
                        />
                      </div>
                      {errors?.cityId?.message && (
                        <span className="error">{errors?.cityId?.message}</span>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            </>
            <Button
              commonClass="common-btn"
              text={`${t("myaccount.personaldetail.save")}`}
              type="submit"
            />
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddAddress;
